import vars from "@/styles/_variables.scss";

// Video tour
export const PLAYBACK_CONST = 350;
export const SCROLL_HEIGHT = 12950; // 16000
export const SCROLL_THROTTLE = 1000 / 15; // 15fps
export const TOUR_OFFSET_DESKTOP = 2500;
export const TOUR_OFFSET_MOBILE = 100;
export const PROGRESS_OFFSET_DESKTOP = 4800;
export const PROGRESS_OFFSET_MOBILE = 2400;
export const MIN_LOAD_TIME = 6000;
export const DESKTOP_ANIMATION_TIME = 2000;
export const DETAIL_POINTS = [
  null,
  null,
  null,
  null,
  null,
  null,
  true,
  true,
  true,
  true,
];
export const SCREEN_CONFIG = {
  defaultScreenClass: "lg",
  breakpoints: [
    parseInt(vars.screenSmMin),
    parseInt(vars.screenMdMin),
    parseInt(vars.screenLgMin),
    parseInt(vars.screenXlMin),
    parseInt(vars.screenXxlMin),
  ],
  containerWidths: [
    parseInt(vars.containerSm),
    parseInt(vars.containerMd),
    parseInt(vars.containerLg),
    parseInt(vars.containerXl),
    parseInt(vars.containerXxl),
  ],
  gridColumns: 12,
  gutterWidth: 18,
};

// Default section visibility settings
export const VIS_OFFSET = { top: 50, bottom: 75 };
export const VIS_MIN_TOP = 50;

export default {};
